import ModusServiceCollection from "../ModusServiceCollection";
import DepthReferenceModel from "../../models/modus/DepthReferenceModel";

/**
 * DepthReference collection
 */
export default class DepthReferenceCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return DepthReferenceModel;
  }

}
